import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Header } from "../../../components/header";
import { CardHeader } from "../../../components/cards";
import { SendIcon } from "../../../components/icons";
import { Loading } from "../../../components/loading";
import { useCms, useUpdateCms } from "../hooks";
import { CmsForm } from "../components";

type IUpdateCms = {
  id: string;
};

export const UpdateCms: React.FC = () => {
  const { id } = useParams<IUpdateCms>();
  const navigate = useNavigate();

  useEffect(() => {
    if (!id) {
      navigate("/");
    }
  }, []);

  const { data, refetch } = useCms(+id!);
  const { form, submit, loading } = useUpdateCms({
    id: +id!,
    onCompleted: () => {
      refetch();
      toast.success("Le CMS a été modifié avec succès");
    },
  });

  useEffect(() => {
    if (data?.cms?.ok && data?.cms?.result) {
      form.setValue("name", data.cms.result.name);
    }
  }, [data]);

  if (!data) {
    return <Loading />;
  }

  return (
    <>
      <Header
        title="CMS"
        subtitle={data?.cms?.result?.name ?? ""}
        buttons={[
          {
            actionText: "Annuler",
            bgColor: "indigo",
            textColor: "white",
            link: `/cms`,
            icon: <SendIcon />,
          },
        ]}
      />
      <div className="main-container">
        <div className="card">
          <CardHeader title="Modifier un CMS" />
          <CmsForm loading={loading} form={form} submit={submit} />
        </div>
      </div>
    </>
  );
};
